module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0034.jpg?v=1accb7a7";